import Vue from 'vue';
import {Component, Watch} from 'vue-property-decorator';
import {IndieLogin} from "@/app/services/indie-login";
import {AffiliateConfigurationService} from "@/app/services/affiliate-configuration.service";
import Clipboard from 'v-clipboard'
import {FULL_BASE_URL} from '@/app/shared/common/constants'

Vue.use(Clipboard);

@Component<Dashboard>({
    components: {},
    beforeRouteLeave(to, from, next) {
        const self = this as any;
        if (self.pendingSave()) {
            if (confirm('You have unsaved changes. Are you sure you want to leave?')) {
                next();
            }
        } else {
            next();
        }
    }
})

export default class Dashboard extends Vue {
    private readonly affiliateConfigurationService = new AffiliateConfigurationService();
    private readonly indieLogin: IndieLogin = new IndieLogin();

    public configuration: any = {
        logo: '',
        tagline: '',
        search_results_settings: {
            short_connections: 0,
            airport_changes: 0,
            baggage_recheck: 0,
        },
        data_collection_questions: [],
        urls: [],
    }
    private newQuestion = '';
    private readonly defaultNewUrl: any = {name: '', url: '', id: 0}
    private newUrl = {name: '', url: '', id: 0};
    private logoImgPreviewElement = null;
    private configurationLoaded = false;
    private saveEnabled = false;

    @Watch('configuration', {deep: true, immediate: false})
    onConfigurationChanged(newVal: any, oldVal: any) {
        if (this.configurationLoaded) {
            this.saveEnabled = true;
        }
    }

    constructor() {
        super();
    }

    public mounted() {
        if (!this.indieLogin.isAffiliate()) {
            this.$router.replace('/')
        }

        this.affiliateConfigurationService.getConfiguration()
            .then(configuration => {
                for (let c in configuration.data) {
                    if (this.configuration.hasOwnProperty(c) && configuration.data[c] !== null) {
                        this.configuration[c] = configuration.data[c]
                    }
                }
                if (this.configuration.logo === '') {
                    this.configuration.logo = 'default';
                }
                this.configuration.urls = this.configuration.urls.reverse();
                this.$nextTick(() => this.configurationLoaded = true)
            }).catch(err => {
            this.configuration.logo = 'default';
        })

    }

    private previewLogo(file: File) {

        // @ts-ignore
        this.$refs.defaultLogo.remove();

        if (this.logoImgPreviewElement) {
            // @ts-ignore
            this.logoImgPreviewElement.remove();
        }

        // @ts-ignore
        this.logoImgPreviewElement = document.createElement("img");
        // @ts-ignore
        this.logoImgPreviewElement.classList.add("obj");
        // @ts-ignore
        this.logoImgPreviewElement.file = file;
        // @ts-ignore
        this.$refs.logoImgPreview.appendChild(this.logoImgPreviewElement);

        const fileReader = new FileReader();
        // @ts-ignore
        fileReader.onload = (e) => {
            // @ts-ignore
            this.logoImgPreviewElement.src = e.target.result;
        };

        fileReader.readAsDataURL(file);
    }

    private saveConfiguration() {
        this.saveEnabled = false;
        this.affiliateConfigurationService.saveConfiguration(this.configuration)
            .then(response => {
                this.$toasted.info("The configuration was saved", {duration: 3000});
            })
    }

    private addQuestion() {
        if (this.newQuestion) {
            this.configuration.data_collection_questions.push(this.newQuestion);
            this.newQuestion = '';
        }
    }

    private removeQuestion(i: number) {
        this.configuration.data_collection_questions.splice(i, 1);
    }

    private addURL() {
        if (this.newUrl.name && this.isValidURL(this.newUrl.url)) {
            this.newUrl.id = this.affiliateConfigurationService.generateUrlId(this.configuration.urls);
            this.configuration.urls.push(this.newUrl);
            this.newUrl = this.defaultNewUrl;
        }
    }

    private isValidURL(url: string) {
        return Dashboard.validURL(url)
    }

    private static validURL(url: string) {
        if (0 !== url.replace(/^https:/, '').indexOf(FULL_BASE_URL.replace(/^https:/, ''))) {
            return false;
        }
        let urlString = new RegExp(/[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi);
        return url.match(urlString);
    }

    private removeURL(i: number) {
        this.configuration.urls.splice(i, 1);
    }

    public copyToClipboard(text: string) {
        //@ts-ignore
        this.$clipboard(text);
        //@ts-ignore
        this.$toasted.info("The URL was copied!", {duration: 1000});
    }

    private get FULL_BASE_URL(){
        return FULL_BASE_URL;
    }

    private fillInIndieUrl() {
        if (!this.newUrl.url || this.newUrl.url === '') {
            this.newUrl.url = FULL_BASE_URL;
        }
    }

    private makeAffiliateUrl(urlString: string, urlId: number) {
        return AffiliateConfigurationService.makeAffiliateUrl(urlString, this.indieLogin.getId(), urlId)
    }

    public pendingSave() {
        return this.saveEnabled;
    }

}
